export const PASSWORD_MINIMUM_CHARACTERS = 6;

export const PASSWORD_MAXIMUM_CHARACTERS = 32;